import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAppConfig } from '../lib/appConfig';
import { usePageHeader } from '../shell/pageHeader';
import { isTalentOnly } from '../shell/nav';
import EmptyState from '../ui/EmptyState';
import PageHeader from '../ui/PageHeader';

// HD-11.1 (P2): a path the app does not have (a mistyped link, /ai while AI Production is off, /ui on a build without the
// sheet). It renders inside the viewer's own frame: the Console for staff, the Portal for talent and clients (AppShell picks
// the frame; PrivateRoute sends a signed-out visitor to sign-in first). One sentence and the way Home.
export default function NotFound() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { loaded } = useAppConfig();
  const navigate = useNavigate();
  // /ai depends on a deployment flag that loads after the first render: rule on it only once the flag is known
  if (!loaded && pathname.toLowerCase().replace(/\/+$/, '') === '/ai') return null;
  const body = <EmptyState message="There is no page at this address." action={{ label: 'Go to home', onClick: () => navigate('/') }} />;
  if (isTalentOnly(user)) {
    return <main className="ui ui-page ui-page--portal" data-testid="not-found"><PageHeader title="Page not found" />{body}</main>;
  }
  return <InShell portal={!!user?.isExternal}>{body}</InShell>;
}

function InShell({ portal, children }) {
  usePageHeader({ title: 'Page not found' });
  return <div className={`ui ui-page${portal ? ' ui-page--portal' : ''}`} data-testid="not-found">{children}</div>;
}
